import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/routes';
import { setLocale } from '@/i18n';

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        // Same page, new query (a search, a filter): stay where the reader is.
        if (to.path === from.path) return false;
        // Anchors (#ayah-255) are scrolled to by the page once its data is in.
        if (to.hash) return false;
        return { top: 0 };
    }
});

// A Quran URL carries its language (/quran → English, /bs/quran → Bosnian, /nl/quran → Dutch…).
router.beforeEach((to) => {
    if (to.meta.quranLocale) setLocale(to.meta.quranLocale);
});

router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next();
    }

    const middleware = to.meta.middleware;

    const context = { next, to, from };
    const iterator = (middlewares, middlewareIndex) => {
        const currentMiddleware = middlewares[middlewareIndex];

        if (!currentMiddleware) {
            return next();
        }

        currentMiddleware(to, from, (...args) => {
            if (args.length) {
                return next(...args);
            }

            iterator(middlewares, middlewareIndex + 1);
        });
    };

    iterator(middleware, 0);
});

export default router;
